<script lang="ts" >
    import type { AdvancementStep } from "./step";

    export let steps: AdvancementStep[] = [];

</script>

<div class="wrapper">
    {#each steps as step}
        <div class="item" class:done={step.done} class:active={step.active} >
            <div class="counter">{ step.number } </div>
            <div class="label"> { step.title } </div>
        </div>
    {/each}
</div>

<style>

    .wrapper {
        margin-top: auto;
        display: flex;
        justify-content: space-between;
    }
    .item {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
    }

    .item::before {
        position: absolute;
        content: "";
        border-bottom: 2px solid  var(--disabled-color);
        width: 100%;
        top: 20px;
        left: -50%;
        z-index: 2;
    }

    .item::after {
        position: absolute;
        content: "";
        border-bottom: 2px solid var(--disabled-color);
        width: 100%;
        top: 20px;
        left: 50%;
        z-index: 2;
    }

    .item .counter {
        position: relative;
        z-index: 5;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #ccc;
        margin-bottom: 6px;
    }

    .item.active {
        font-weight: bold;
    }

    .item.done .counter {
        background-color: var(--primary-color);
        color: var(--primary-contrast);
    }

    .item.done::after {
        position: absolute;
        content: "";
        border-bottom: 2px solid var(--primary-color);
        width: 100%;
        top: 20px;
        left: 50%;
        z-index: 3;
    }

    .item:first-child::before {
        content: none;
    }
    .item:last-child::after {
        content: none;
    }


</style>